import { DeviationEnum, DeviationTipEnum } from 'gql/graphql';

import type { ICellRendererParams } from 'ag-grid-community';
import { useMemo } from 'react';

import { TooltipWrapper } from '../TooltipWrapper';

import Style from './DeviatedValueCellRendererComponent.module.css';

interface IDeviatedValueCellRendererComponentProps extends ICellRendererParams {
    checkDeviation?: boolean;
    checkDeviationTip?: boolean;
    deviationKey?: string;
    deviationTipKey?: string;
}

export const DeviatedValueCellRendererComponent = (props: IDeviatedValueCellRendererComponentProps) => {
    const { checkDeviation, checkDeviationTip, deviationKey, deviationTipKey, data, valueFormatted } = props;

    const showArrowUp = useMemo(() => {
        const deviation = deviationKey && data?.[deviationKey];

        return checkDeviation && deviation === DeviationEnum.Up;
    }, [checkDeviation, data, deviationKey]);

    const showWarningMessage = useMemo(
        () => deviationTipKey && data[deviationTipKey] === DeviationTipEnum.LessThan30,
        [data, deviationTipKey],
    );

    const colorToRed = useMemo(
        () => deviationTipKey && data[deviationTipKey] === DeviationTipEnum.Negative,
        [data, deviationTipKey],
    );

    if (checkDeviationTip) {
        return showWarningMessage ? (
            <TooltipWrapper message="Остаток меньше 30%" className={Style.warning}>
                {valueFormatted}
            </TooltipWrapper>
        ) : (
            <div className={colorToRed ? Style.alertColorValue : undefined}>{valueFormatted}</div>
        );
    }

    if (checkDeviation) {
        return (
            <span>
                {showArrowUp && <span className={Style.arrow}>▲</span>}
                <span>{valueFormatted}</span>
            </span>
        );
    }

    return <div>{valueFormatted}</div>;
};

DeviatedValueCellRendererComponent.displayName = 'DeviatedValueCellRendererComponent';
